import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDataTable,{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.rules,"hide-default-footer":"","no-data-text":_vm.$t('components.audiences.rulesView.datatable.noData')},on:{"click:row":_vm.rowSelected},scopedSlots:_vm._u([{key:"item.text",fn:function(ref){
var item = ref.item;
return [_c('span',{domProps:{"innerHTML":_vm._s(item.text)}})]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-end"},[_c(VBtn,{attrs:{"text":"","icon":"","color":"error"},on:{"click":function($event){$event.stopPropagation();return _vm.removeRule(item.id)}}},[_c(VIcon,[_vm._v("mdi-delete")])],1)],1)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }